<!-- ngView: -->
<div id="contents" role="main" data-ng-view="" class="ng-scope" style="min-height: 395px;">
	<div class="progress ng-scope">
		<ul>
			<li class="done"><i class="sp ico_progress1"></i><span>SELECT PRODUCT</span></li>
			<li class="done"><i class="sp ico_progress2"></i><span>INPUT PERSONAL INFORMATION</span></li>
			<li class="done"><i class="sp ico_progress3"></i><span>MAKE PAYMENT</span></li>
			<li class="active"><i class="sp ico_progress4"></i><span>COMPLETE PAYMENT</span></li>
		</ul>
	</div>

	<div class="container ng-scope">
		<section class="flex_ctr_bx">
			<div class="form_wrap sec_complete">
				<img src="./assets/images/check.png" width=70 style="margin-bottom:20px;">
				<h3 class="htit ng-binding">
<!--i class="sp img_compelete"></i-->You have successfully registered!</h3>
<p>Thank you for your order. You are now covered by Samsung Care+</p>
				<div class="inner">
					<div class="order-detail-title">Order Details<div class="arrow-down"></div></div>
				
					<div class="order-details">
						<!--
						<div class="order-number">
								<div>
									<span class="order-subtitle">Order Number</span>
									<span>C3A05A54</span>
								</div>
								<div>
									<span class="order-subtitle">Contract Number</span>
									<span>600012095</span>
								</div>
						</div>
						-->
					<ul>
						<li><span class="tit">PRODUCT</span><div>{{product.SKUDESC}}</div></li>
						<li><span class="tit">COVERAGE</span><div>Additional {{product.TERM}}-months coverage</div></li>
						<li><span class="tit">MODEL CODE</span><div>{{modelCode}}</div></li>
						<li><span class="tit">SERIAL NUMBER</span><div>{{serialNumber}}</div></li>
					</ul>
						<!-- ngIf: vm.productName --><span class="info_detail ng-binding ng-scope" data-ng-if="vm.productName"
						data-ng-bind-html="vm.productName | htmlSafe">Samsung Care+</span><!-- end ngIf: vm.productName -->
					<div class="order-total">
					
						<span>Order Total</span><strong class="info_price ng-binding"><span class="dollar-text">$</span>{{total}}</strong></div>
					<!-- ngIf: vm.countryCd == 'AUS' -->
				</div>
				</div>
				<!-- ngIf: vm.PATH_COUNTRY === 'br' -->
				<div class="needhelp">
					<h3>Need Help?</h3>
					<p>If you have any question or need help with your order, please contact us at 866-371-9501</p>
				</div>
			</div>
		</section>
		<!-- ngIf: !vm.IS_PARTNER_PORTAL_IN -->
		<div class="btn_area ng-scope" data-ng-if="!vm.IS_PARTNER_PORTAL_IN"
			data-ng-class="{'only': vm.PATH_COUNTRY === 'br'}">
			<!-- ngIf: vm.PATH_COUNTRY !== 'br' -->
			<a class="btn btn_type2 ng-binding ng-scope"
				data-ng-if="vm.PATH_COUNTRY !== 'br'" (click)="onMain()"><img src="./assets/images/button-arrow-pre.png">Back to Home</a>
			<!-- end ngIf: vm.PATH_COUNTRY !== 'br' -->
			<a class="btn btn_type1 ng-binding" (click)="onCheckOrderStatus()">View Order Detail<img src="./assets/images/button-arrow.png"></a>
		</div><!-- end ngIf: !vm.IS_PARTNER_PORTAL_IN -->
		<!-- ngIf: vm.IS_PARTNER_PORTAL_IN -->
	</div>
</div>